import React from 'react';

import { Empty, Spin } from 'antd';
import {
  Bar,
  Brush,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import IntlMessages from 'util/IntlMessages';

import { COLORS_PALETTE } from '../../../constants';

export const renderCountChartContent = ({ data, loading, widgetId, ref, widget, additionalState }) => {
  if (!data || !data.metrics) {
    return loading ? <Spin size="large" /> : <Empty className="gx-m-auto" description={<IntlMessages id="components.empty.description" />} />;
  }

  const { aggregations } = widget;
  const chartTypes = {
    bar: ({ key, ...props }) => <Bar barSize={20} dataKey={key} {...props} />,
    line: ({ key, ...props }) => <Line dataKey={key} type="monotone" connectNulls {...props} />,
  };
  const barColors = additionalState?.barColors || {};

  return (
    <>
      {!loading && !!data.metrics?.length && (
        <ResponsiveContainer width="100%" height="100%" minHeight={0} className="cancelDrag">
          <ComposedChart data={data.metrics} ref={ref}>
            <XAxis dataKey="key" key={`${widgetId}_xaxis`} />
            <YAxis />
            <Tooltip />
            <Legend />
            <CartesianGrid stroke="#F5F5F5" />
            {data.dimensionKeys?.length > 0
              ? data.dimensionKeys.map(({ key, name }, idx) => (
                  <React.Fragment key={`${widgetId}_dimension_${idx}_${key}`}>
                    {chartTypes[aggregations?.count?.displayType || 'bar']?.({
                      key: `dimension_${key}`,
                      dataKey: `dimension_${key}`,
                      name,
                      fill: barColors[key] || COLORS_PALETTE[idx % COLORS_PALETTE.length],
                    })}
                  </React.Fragment>
                ))
              : chartTypes[aggregations?.count?.displayType || 'bar']?.({
                  dataKey: 'count',
                  fill: Object.values(barColors)[0] || COLORS_PALETTE[0],
                  legendType: 'none',
                })}
            <Brush dataKey="key" height={30} stroke="#8884D8" tick={false} />
          </ComposedChart>
        </ResponsiveContainer>
      )}
      {loading && <Spin size="large" />}
      {!loading && !data.metrics?.length && (
        <Empty className="gx-m-auto" description={<IntlMessages id="components.empty.description" />} />
      )}
    </>
  );
};

